import { defineComponent as _defineComponent } from 'vue'
import { useContext, useStore } from '@nuxtjs/composition-api';
import { State } from '~/store';

interface Props {
  icon: string;
  title: string;
  dataCy: string;
  resourceProperty?: string;
  eventParams?: Record<string, unknown>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceHeaderProperty',
  props: {
    icon: null,
    title: null,
    dataCy: null,
    resourceProperty: null,
    eventParams: null
  },
  setup(__props: any) {

const props = __props as {
  icon: string;
  title: string;
  dataCy: string;
  resourceProperty?: string;
  eventParams?: Record<string, unknown>;
};

const store = useStore<State>();


function showCurriculumModal() {
  store.dispatch('modals/show', 'resourceCurriculum');
}

return { __sfc: true,store, props, showCurriculumModal }
}

})